<template>
  <div>
    <CreateCategory
      v-bind:id="id"
      v-on:close-modal="modalToggle"
      v-bind:createCategoryModal="createCategoryModal"
    />
    <div class="container container-dashboard">
      <div class="title">
        <h2>Document Library</h2>
        <i v-if="isAdmin" @click="modalToggle" class="fal fa-plus-circle"></i>
      </div>
      <div class="categorys">
        <CategoryIndex />
        <Categorys v-bind:categories="categories" />
      </div>
    </div>
  </div>
</template>

<script>
import CategoryIndex from "./CategoryIndex";
import CreateCategory from "./CreateCategory";
import Categorys from "./Categorys";
import { getUserInfo } from "../../mixins/getUserInfo";

export default {
  name: "Category",
  components: {
    Categorys,
    CategoryIndex,
    CreateCategory,
  },
  mixins: [getUserInfo],
  props: ["uploadDocumentModal", "categories"],
  data() {
    return {
      createCategoryModal: false,
    };
  },
  created() {},

  methods: {
    modalToggle() {
      this.createCategoryModal = !this.createCategoryModal;
    },
  },
};
</script>

<style lang="scss">
.index {
  display: flex;
}

.category-index,
.category-wrap {
  color: black;
  text-decoration: none;
  padding: 24px 32px;
  display: flex;
}

.name,
.number-items,
.date,
.created-by {
  flex: 1;
}

.category-wrap {
  &:hover {
    color: white;
  }
  i {
    color: rgba(99, 56, 255, 1);
  }
}

.category-index {
  i {
    margin-right: 14px;
    color: rgba(99, 56, 255, 1);
  }
}

.category {
  position: relative;
  transition: 500ms ease background-color;
  border-bottom: 1px solid #f1f1f1;

  &:hover {
    cursor: pointer;
    background-color: rgba(99, 56, 255, 0.5);
    color: white;
  }
}

.name {
  display: flex;

  i {
    margin-right: 14px;
  }
}
</style>
